module.exports = __webpack_public_path__ + "static/media/icn_ledger.62825e60.svg";